module.exports = __webpack_public_path__ + "omniv2/img/logo-flat-inverted.ec7fe3c8.svg";